<!-- 

/financeiro/fluxodecaixa

-->

<script>
import BarList from '../components/bar-list'
import BarGrid from '../components/bar-grid'
import FilterList from '../components/filter-list'
import Filtro from "../consultas/filtro";
import { apiORDSpost } from '../shared/api-functions'
import { GChart } from 'vue-google-charts/legacy'

export default {
    data () {
        return {
            filter: '',
            metadata: this.$store.getters.getEntities.metadata,
            moreActionsBarList: [],
            monthFilter: {},
            statusQuery: '',
            filterList: [],
            paramFilterList: {},
            showForm: false,
            codfin: '',
            url: '',
            textQuery: '',
            dados: [],
            resumo: [],
            totais: null,
            dadosDre: null,
            showModal: false,
            showModalDiario: false,
            dadosDetalhes: '',
            contas: null,
            listContas: null,
            atrasos: false,
            atrasosTempo: null,

            //OBJETO PARA MONTAGEM DO FILTRO DA CONSULTA
            showfiltro: false,

            tipo: null,
            listPeriodos: [
              { id: 'MENSAL', text: 'Mensal'},
              { id: 'TRIMESTRAL', text: 'Trimestral'},
              { id: 'ANUAL', text: 'Anual'},
            ],
            ano: null
            
        }
    },

    computed: {
      
    },

    watch: {
        
    },

    methods: {
        // showModalDetalhes(dados, idxPeriodo) {
        //     let dataIni = null;
        //     let dataFim = null;
        //     if (this.dadosDre.periodos[idxPeriodo].inicio)
        //       dataIni = new Date(this.dadosDre.periodos[idxPeriodo].inicio)
        //     if (this.dadosDre.periodos[idxPeriodo].termino)  
        //       dataFim = new Date(this.dadosDre.periodos[idxPeriodo].termino)
        //     let data = null

        //     let detalhes = dados.detalhes.filter(function (obj) {
        //         data = new Date(obj.dtvr)
        //         if ((!dataIni) || (!dataFim) || (data >= dataIni && data <= dataFim))
        //           return obj
        //     })

        //     this.dadosDetalhes = {...dados}
        //     this.dadosDetalhes.detalhes = detalhes

        //     this.showModal = true
        // },

        // showModalDetalhesDiario(detalhes, dataDia) {
        //     this.diario.dataDia = dataDia
        //     this.diario.diarioDetalhes = detalhes
        //     this.showModalDiario = true
        // },

        // closeModalDetalhes() {
        //     this.showModal = false
        //     this.showModalDiario = false
        // },

        loadData() {
            let url = "consulta/vendas/dre";
            let filtro = { 
                ano: this.ano,
                tipo: this.tipo
            }

            this.mounting = true
            let self = this
            apiORDSpost(this.$store, url, filtro, "post").then((data) => {
                if (data.dre && data.dre.length)
                    self.dadosDre = data
                else  
                    self.dadosDre = null
                console.log(this.dadosDre)
            })

        },

        formatColorValue(value) {
            if (value < 0) {
                return 'negative'
            }

            if (value > 0) {
                return 'positive'
            }

            return ''
        },

        levelClass(dre) {
          switch (dre.nivel) {
            case 0:
              return 'lvl-0'

            case 1:
              return 'lvl-1'
        
            case 2:
              return 'lvl-2'
          }
        }, 

        levelBorderClass(dre) {
          switch (dre.nivel) {
            case 0:
              return 'border-left-gray'

            case 1:
              return 'border-left-gray'
        
            case 2:
              return dre.tipo === 'R' ? 'border-left-green' : 'border-left-red'
          }
        }
    },

    filters: {

    },

    components: {
        BarList, BarGrid, FilterList, Filtro, GChart
    },

    created () {
        const date = new Date();
        this.ano = date.getFullYear();
        this.tipo = 'TRIMESTRAL'
        this.loadData()
    }

}
</script>

<template>
    <div>         
        <div class="default-container position-relative">
            <div class="row">
                <div class="col-12 mb-2">
                    <span class="lbl-deal-title mb-2 w-100">CONSULTA DRE</span>
                </div>
            </div>
            <hr />
            <div class="row">
                <form-field
                  v-model="tipo"
                  :select-options="listPeriodos"
                  col="2"
                  label="Período"
                  type="select"
                  :optionnull="true"
                ></form-field>

                <form-field
                  v-model="ano"
                  col="2"
                  label="Ano"
                  placeholder="Ex.: 1999"
                  type="text"
                ></form-field>

                <v-button
                  :success="true"
                  @click="loadData"
                  label="Consultar"
                ></v-button>
            </div>

            <div class="data-table bg-light" v-if="dadosDre">
                <table class="table table-bordered table-sm responsive w-100">
                    <tbody>
                        <tr v-if="dadosDre && dadosDre.periodos">
                            <th class="text-center" scope="row">CATEGORIAS</th>
                            <th colspan="1" class="numerico size100 textual text-center" v-for="(periodo, i) in dadosDre.periodos" :key="i">
                                {{ periodo.label }}
                            </th>
                            <th class="text-center" scope="row">TOTAL</th>
                        </tr>

                        <tr v-for="(dados, i) in dadosDre.dre" :key="i">
                            <th class="textual" :class="levelBorderClass(dados)">
                                <span v-if="!dados.nivel" class="totalizer">=</span>
                                <span v-if="dados.nivel === 1" class="totalizer"></span>
                                <div :Class="levelClass(dados)">
                                    {{ dados.descricao }}
                                </div>
                            </th>
                            <td class="numerico size100 value-bg-color" v-for="(valor, i) in dados.colunas" :key="i">
                                <span :class="formatColorValue(valor)">
                                    <!-- <i class="fa fa-search fa-fw" v-if="!dados.haschildren && valor" @click="showModalDetalhes(dados, i)"></i>  -->
                                    {{ valor | formatValue(2, true) }}
                                </span>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <!-- <tr>
                            <th colspan="1" class="text-center"></th>
                            <th colspan="1" class="numerico size100" v-for="(periodo, i) in dadosDre.periodos" :key="i">
                                {{ periodo.label }}
                            </th>
                        </tr> -->
                    </tfoot>
                </table>
            </div>

            <!-- Modal Detalhes Diário -->
            <!-- <div class="nb-modal-scrollable" v-if="showModalDiario">
                <div class="container nb-modal-scrollable-container nb-email-container">
                    <div class="nb-modal-header">
                        <h5 class="p-2" v-if="diario.dataDia === 'Atrasos'">Detalhes {{ diario.dataDia }}</h5>
                        <h5 class="p-2" v-else>Detalhes do dia {{ diario.dataDia | formatData }}</h5>
                        <button type="button" class="close" @click="closeModalDetalhes()" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="nb-modal-scrollable-body">
                        <div class="mainbox">
                            <div class="box" v-for="(detalhe, index) in diario.diarioDetalhes" :key="index">
                                <div class="row">
                                    <div class="col-md-1 col-3" style="float: left">
                                        <label class="lbl-list w-100">Documento</label><span class="data-list">{{ detalhe.doc }}</span>
                                    </div>
                                    <div class="col-md-3 col-3">
                                        <label class="lbl-list w-100">Nome</label><span class="data-list">{{ detalhe.nome }}</span>
                                    </div>
                                    <div class="col-md-2 col-3">
                                        <label class="lbl-list w-100">Descrição</label><span class="data-list">{{ detalhe.descricao }}</span>
                                    </div>
                                    <div class="col-md-1 col-3">
                                        <label class="lbl-list w-100">Valor</label><span class="data-list">{{ detalhe.vlr | formatValue(2, true) }}</span>
                                    </div>
                                    <div class="col-md-2 col-3">
                                        <label class="lbl-list w-100">Vencimento</label><span class="data-list">{{ detalhe.dtv | formatData }}</span>
                                    </div>
                                    <div class="col-md-2 col-3">
                                        <label class="lbl-list w-100">Vencimento Real</label><span class="data-list">{{ detalhe.dtvr | formatData }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="nb-modal-scrollable-footer">
                            <v-button ref="btnClose" label="Cancelar" title="" @click="closeModalDetalhes()"></v-button>
                        </div>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</template>

<style scoped>

.data-table {
    overflow: auto;
}

span i {
    cursor: pointer;
}

.lvl-1 {
    font-size: 15px !important;
    margin-left: .75rem;
}

.lvl-2 {
    margin-left: 1.75rem;
}

.lvl-0 {
    font-size: 15px !important;
    margin-left: .75rem;
}

table .textual {
    font-size: 12px;
    padding: 4.8px;
}

table .numerico {
    font-size: 12px;
    min-width: 65px;
    text-align: right;
}

table .size130 {
  min-width: 130px;
}

table .size100 {
  width: 100px;
}

table .total {
    background: #c1c4c7;
    border: none;
}

table .var {
    min-width: 85px;
    text-align: center;
    background: #c1c4c7;
    display: inline-block;
}

table .var-negative {
    color: white;
    background: indianred;
}

table .var-positive {
    color: white;
    background: green;
}

table .border-left {
  border-left: 1px solid #dee2e6;
}

.value-bg-color {
    background-color: #fafffa !important;
}

.consulta__total {
  display: flex;
  align-items: center;
  justify-content: center;
}

.consulta__total_valor {
  font-size: 40px;
  display: block;
  line-height: normal;
}

.consulta__cifrao {
  font-size: 16px;
  display: block;
  line-height: normal;
}

.negative {
  color: red;
}

.positive {
  color: green
}

.border-left-gray {
  border-left: 7px solid gray;
}

.border-left-green {
  border-left: 7px solid #28a745;
}

.border-left-red {
  border-left: 7px solid #ee2727;
}

.totalizer {
  position: absolute;
  left: .60rem;
  width: 16px;
  height: 16px;
  border: 1px solid #ccc;
  background-color: white;
  border-radius: 8px;
  color: black;
  margin-top: 3px;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>



// WEBPACK FOOTER //
// src/forms-consultas/consulta-dre.vue